import { doBulkUpdate } from './doBulkUpdate'
import { doStar } from './doStar'

export const doBulkStar = (ticketIds, options = {}) => dispatch => {
  return dispatch(doBulkUpdate(ticketIds, doStar, [], options))
}
